<template>
  <div class="department-tab" v-if="sources.length>0">
    <van-tabs v-model="active" title-active-color="var(--main-color)" color="var(--main-color)" @change="onClickTab">
      <van-tab v-for="(item, index) in sources" :title="item.name" :key="index">
        <div class="type-box" v-if="item.child && item.child != null && item.child.length > 0">
          <span :class="{'active': typeActive == idx}" v-for="(child, idx) in item.child" :key="idx" @click="typeHandle(idx, child.name)">{{child.name}}</span>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  name: "DepartmentTab",
  props:['sources'],
  data() {
    return {
      active: 0,
      typeActive: 0
    }
  },
  methods: {
    onClickTab() {
      this.typeActive = 0;
      this.$emit('onClickTab', this.active);
    },
    typeHandle(index, name, isRest) {
      if (index != this.typeActive || isRest) {
        this.typeActive = index;
        this.$emit('typeHandle', index, name)
      }
    },
    resetActive() {
      this.active = 0;
    },
    resetTypeActive() {
      this.typeActive = 0;
    }
  }
}
</script>

<style lang="scss" scoped>
.type-box{
  height: 25px;
  padding: 15px;
  background: #fff;
  span{
    display: inline-block;
    padding: 0 15px;
    height: 25px;
    line-height: 25px;
    margin-right: 10px;
    font-size: 13px;
    box-sizing: border-box;
    border-radius: 13px;
    border: 1px solid #eee;
    &.active{
      color: var(--main-color);
      border-color: var(--main-color);
    }
  }
}
</style>
